import { createRoot } from 'react-dom/client';
import { SessionProvider, useSession } from './lib/session';
import { ApprovalProvider, Spinner, ToastProvider } from './ui/kit';
import { PrintProvider } from './ui/print';
import { CloudPrintProvider } from './lib/printing';
import { LockScreen, SetupLinkScreen, SetupScreen, TabletSetupScreen, setupLinkToken } from './screens/Gate';
import { Shell } from './screens/Shell';
import { LegalFooter } from './ui/legal';
import { SignedOutUpdater } from './lib/update';
import { DemoBar, DemoKeyScreen } from './screens/Demo';
import { PlatformGate } from './screens/Platform';
import { PlanProvider } from './lib/plan';

function Root() {
  const { status, me, loading } = useSession();
  if (loading || !status) return <div className="gate"><Spinner label="Starting STORE OS" /></div>;
  // A private demo: the access key first.
  if (status.demo_locked) return <DemoKeyScreen />;
  // Opened from a setup link: make this computer a store's tablet.
  const setupToken = setupLinkToken();
  if (setupToken && !status.needs_setup) return <><SetupLinkScreen token={setupToken} /><LegalFooter /></>;
  if (me) return <><DemoBar /><PlanProvider><Shell /></PlanProvider></>;
  // Several businesses on this server and nobody signed in on this device: Store OS's own sign-in
  // and signup (no business's name, people or screens until someone signs in).
  if (status.platform?.lobby && !status.device) return <><PlatformGate /><LegalFooter /><SignedOutUpdater /></>;
  return (
    <>
      <DemoBar />
      {status.needs_setup ? <SetupScreen /> : status.device ? <LockScreen /> : <TabletSetupScreen />}
      <LegalFooter />
      <SignedOutUpdater />
    </>
  );
}

createRoot(document.getElementById('root')!).render(
  <ToastProvider>
    <SessionProvider>
      <ApprovalProvider>
        <PrintProvider>
          <CloudPrintProvider>
            <Root />
          </CloudPrintProvider>
        </PrintProvider>
      </ApprovalProvider>
    </SessionProvider>
  </ToastProvider>,
);
